<template>
  <div class="medium-12">
    <div class="margin-b-xs" v-if="!isCorporate">
      <label class="field-checkbox">
        <input type="checkbox" v-on:click="showHideForm" class="margin-r-xs" ref="checkbox"
          v-model="guestChecked" @change="updateGuestInfo" v-show="false" />
        <i class="fas fa-check-square chkbox fa-fw" v-if="!isHidden"></i>
        <i class="far fa-square fa-fw" v-else></i>
        {{ $t('customerForm.bookForSomeone') }}
      </label>
    </div>
    <div ref="GuestForm" v-bind:class="['guest-form showhide-fadeslide', (isHidden? 'hide' : ''), (isCorporate ? 'is-corporate' : '')]">
      <form action="#" :class="['padding-a-m', isSafari]" data-vv-scope="guest-form">
        <h3 class="margin-t-z margin-b-s">{{ $t('customerForm.paxInfo') }}</h3>
        <div class="row">
          <div class="medium-6 column padding-r-s small-padding-h-z">
            <div :class="['field-group', {'field-error': error.firstName}]">
              <label class="field-label">{{ $t('customerForm.firstName') }}</label>
              <input type="text" name="fname" placeholder="John" class="field-text" 
                v-model="firstName" @change="updateGuestInfo" ref="firstName" />
              <span v-show="error.firstName" class="field-error-message">{{ error.firstName }}</span>
            </div>
          </div>
          <div class="medium-6 columns padding-l-s small-padding-h-z">
            <div :class="['field-group', {'field-error': error.lastName}]">
              <label class="field-label">{{ $t('customerForm.lastName') }}</label>
              <input type="text" name="lname" placeholder="Doe" class="field-text" 
                v-model="lastName" @change="updateGuestInfo" />
              <span v-show="error.lastName" class="field-error-message">{{ error.lastName }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns">
            <mobile-input ref="guestMobile"
            :mobile="mobile" :isGuest="true"
            :needVerification="false" :required="mobileRequired" 
            @updateMobile="updateGuestInfo" @guestMobileValidate="guestMobileValidate"
          ></mobile-input>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import MobileInput from '../Global/MobileInput.vue'

Vue.use(VeeValidate)

export default {
  name: 'guest-form',
  data () {
    return {
      isHidden: !this.$store.state.guestInfo.proxy,
      firstName: this.$store.state.guestInfo.firstName,
      lastName: this.$store.state.guestInfo.lastName,
      mobile: this.$store.state.guestInfo.mobile,
      countryCode: this.$store.state.guestInfo.countryCode,
      mobileRequired: false,
      guestChecked: this.$store.state.guestInfo.proxy,
      isSafari: navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : '',
      error: {
        firstName: '',
        lastName: ''
      }
    }
  },
  components: { 'mobile-input': MobileInput },
  computed: {
    isCorporate () { return this.$store.state.user.isCorporate }
  },
  methods: {
    showHideForm: function () {
      this.isHidden = !this.isHidden
      this.$emit('clicked', !this.isHidden)
      if (!this.isHidden) {
        this.$refs.firstName.focus()
        this.$scrollTo(this.$refs.GuestForm)
      } else {
        this.errors.items = []
      }
    },
    updateGuestInfo: function (data) {
      if (data.mobile) {
        this.mobile = data.mobile
        this.countryCode = data.countryCode
      }

      this.$emit('updateInfo', {
        'checked': this.guestChecked,
        'firstName': this.firstName,
        'lastName': this.lastName,
        'mobile': this.mobile,
        'countryCode': this.countryCode
      })

      this.$store.commit('user/setGuestFname', this.firstName)
      this.$store.commit('user/setGuestLname', this.lastName)

      this.$emit('valid', false)
      if (this.firstName && this.lastName) {
        this.$emit('valid', true)
      }
    },
    validateGuestForm: function () {
      let hasError = false
      this.error = {
        firstName: '',
        lastName: ''
      }
      if (!this.firstName) {
        hasError = true
        this.error.firstName = this.$t('common.fieldRequired', {field: 'first name'})
      }
      if (!this.lastName) {
        hasError = true
        this.error.lastName = this.$t('common.fieldRequired', {field: 'last name'})
      }
      this.$emit('valid', hasError)

      if (this.$refs.guestMobile.triggerValidate()) {
        this.$refs.guestMobile.triggerValidate()
      }
    },
    guestMobileValidate (val) {
      if (!val) {
        // this.$emit('mobileValid', false)
      }
    },
    forceHide: function () {
      if (this.guestChecked) {
        this.showHideForm()
      }
      this.guestChecked = false
    }
  },
  watch: {
    guestChecked: function (val) {
      this.$store.commit('setEnableGuestInfo', val)
    },
    isCorporate: function (val) {
      this.isHidden = !val
      this.mobileRequired = val
    }
  },
  mounted () {
    if (this.isCorporate) {
      this.isHidden = false
    }

    let _rsvp = this.$store.state.reservation.leg1
    if (_rsvp.pickup && !_rsvp.pickup.title) {
      this.guestChecked = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Customer/GuestForm.scss";
h3{ font-size: 1.3rem!important; }
.field-checkbox{
  .far, .fas{
    margin-right: 3px;
    font-size: 15px;
    vertical-align: -1px;
  }
}
.fa-check-square.chkbox{
  color: #0075ff;
}
</style>



// WEBPACK FOOTER //
// GuestForm.vue?440b80fa